export default "__VITE_ASSET__7de4e838__"